export const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const deCapitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toLowerCase() + s.slice(1);
};

export const insert = (valueToModify, index, string) => {
    if (index > 0)
        return valueToModify.substring(0, index) + string + valueToModify.substring(index, valueToModify.length);

    return string + valueToModify;
};